import React from 'react'
import '../App.css'
import Header from "../Components/Header.js"
import { useEffect } from 'react'
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import styled from "styled-components";
import { Link } from 'react-router-dom';

const HiddenHotspot = styled(Link)`
  position: absolute;
  /* Centratura orizzontale */
  left: 50%;
  transform: translateX(-50%);
  
  /* Dimensione: 1/3 della larghezza */
  width: 36vw; 
  
  /* Altezza (regolabile in base alle tue esigenze) */
  height: 245px; 
  
  /* Posizionamento: leggermente sotto la mediana (50%) */
  top: 53%; 

  /* Invisibilità totale */
  background: transparent;
  border: none;
  cursor: pointer;

  /* Rimuove stili di default dei link */
  text-decoration: none;

  /* Debug: decommenta la riga sotto per vedere l'area mentre la posizioni */
  /* border: 2px solid red; */
`;

export default function Home() {
 
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  
  const myStyle = {
    backgroundImage:
        "url('/background.png')",
    height: "100vh",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  }

  return (
    <div style={myStyle}>
      <Header />
      <HiddenHotspot to="/book" title="Vai al Libro" />
   </div>
  )
}